// extracted by mini-css-extract-plugin
export var clone = "_sb-2";
export var displayNone = "_sb-4";
export var expandableItem = "_sb-5";
export var expanded = "_sb-6";
export var folderItem = "_sb-7";
export var ghost = "_sb-1";
export var hidden = "_sb-3";
export var pipeContainer = "_sb-8";
export var wrapper = "_sb-0";